/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["h1[_ngcontent-%COMP%]{margin:15px;height:37px}ngx-monaco-editorLast[_ngcontent-%COMP%]{height:calc(90vh - 80px);width:100%;padding:15px}ngx-monaco-editor[_ngcontent-%COMP%]{height:76vh;width:100vw;padding:0;margin:0;background-color:skyblue}div.scroll[_ngcontent-%COMP%]{margin:4px,4px;padding:4px;background-color:skyblue;height:calc(30vh);overflow-x:hidden;overflow-y:auto;text-align:justify}"];
export { styles as styles };

